import React from 'react'
import {motion} from 'framer-motion'
import me from '../../assets/me.jpg'
const Founder = () => {
    const options = {
        initial: {
          x: "-100%",
          opacity: 0,
        },
        whileInView: {
          x: 0,
          opacity: 1,
        },
      };
  return (
    <section className='founder'>
        <motion.div {...options}>
            <img src={me} alt="ownerPhoto" />
            <h3>Muhammad Hasnine</h3>
            <p>
            Hey, Everyone I am Muhammad Hasnine, the founder of Torkari Wala.
          <br />
          Eat lots of fresh vegetables, drink water, exercise often, and meditate daily.
            </p>
        </motion.div>
        </section>
  )
}

export default Founder